export const WUJIE_EVENT_NAME = {
    runtimePageLoaded: 'runtimePageLoaded', // 运行时页面加载完成
    approvalSubmit: 'approvalSubmit', // 流程-审批页面片-提交审批事件触发
    approvalError: 'approvalError', // 流程-审批页面片-提交审批事件,出错时触发
};
export const wujieEventEmit = (eventName, data) => {
    if (window.$wujie?.bus) {
        window.$wujie?.bus.$emit(eventName, data);
    }
};
